import React, { useState, useEffect } from "react";
import axios from "axios";
import gemIcon from "../../assets/images/gem-icon.png";
import coinIcon from "../../assets/images/coin-icon.png";
import useIcon from "../../assets/images/user-icon.png";
import { useLiffProfile } from "../../context/LiffProfileContext";
import LoadingBar from "../LoadingBar";
import { Translation, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { MaskInputHelper } from "../helpers/mask-input-helper";

const ProfileInfoLine = () => {
  const { t, i18n } = useTranslation();
  const { authToken, userId, profile } = useLiffProfile();
  const [userData, setUserData] = useState(null);
  const [pointData, setPointData] = useState(null);
  const [bigCardNumber, setBigCardNumber] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ตรวจสอบ bigCardNumber หลังโหลดเสร็จ
  // useEffect(() => {
  //   if (!loading && userData && !userData.bigCardNumber) {
  //     navigate("/login");
  //   }
  // }, [loading, userData, navigate]);

  // useEffect(() => {
  //   if (!loading && userData && !userData.bigCardNumber) {
  //     navigate("/login");
  //   }
  // }, [loading, userData, navigate]);

  // useEffect(() => {
  //   if (profile?.displayName === "Guest") {
  //     navigate("/login");
  //   }
  // }, [profile]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        if (userId) {
          const apiUrl = `${process.env.REACT_APP_API_URL}/api/users/current`;
          const clientAuth = process.env.REACT_APP_CLIENT_AUTH;

          const userResponse = await axios.get(apiUrl, {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "X-Client-Auth": clientAuth,
              "x-user-id": userId,
              "Accept-Language": i18n.language.toUpperCase(),
            },
          });

          if (userResponse.data?.data) {
            const user = userResponse.data.data;
            setUserData(user);

            if (user.bigCardNumber) {
              const pointUrl = `${process.env.REACT_APP_API_URL}/api/users/current/clm-point`;
              const pointResponse = await axios.get(pointUrl, {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                  "X-Client-Auth": clientAuth,
                  "x-user-id": userId,
                  "Accept-Language": i18n.language.toUpperCase(),
                },
              });

              if (pointResponse.data?.data) {
                setPointData(pointResponse.data.data);
              }
            }
          }
        }
      } catch (error) {
        console.error("Error fetching user or point data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchData();
    }
  }, [authToken, userId]);

  if (loading) {
    return <LoadingBar />;
  }

  return (
    <div className="w-full max-w-md">
      <div className="flex text-secondary-text-invert gap-1 flex-col">
        {userData?.bigCardNumber && (
          <div className="flex text-secondary-text-invert gap-1">
            <a href="/my-bigpoint">
              <img src={useIcon} alt="Gem Icon" className="w-3 h-3" />
            </a>
            <span className="text-xs font-normal opacity-60">
              {userData?.bigCardNumber}
            </span>
          </div>
        )}
        <div className="text-secondary-text-invert text-xl font-normal text-left">
          {profile?.displayName ?? ""}
        </div>
        {userData?.bigCardNumber && (
          <div className="w-full flex gap-2 font-semibold text-base">
            <div className="flex p-1 justify-between items-center gap-1 bg-secondary-background rounded-full basis-32 h-8 bg-white">
              <img src={coinIcon} alt="Coin Icon" className="w-6 h-6" />
              <span className="mr-2 text-black">
                {MaskInputHelper.formatNumber(pointData?.pointBalance || 0)}
              </span>
            </div>
            <div className="flex p-1 justify-between items-center gap-1 bg-secondary-background rounded-full basis-32 h-8 bg-white">
              <img src={gemIcon} alt="Gem Icon" className="w-6 h-6" />
              <span className="mr-2 text-black">
                {MaskInputHelper.formatNumber(userData?.totalGamePoint || 0)}
              </span>
            </div>
          </div>
        )}
        {/* <div className="w-full flex gap-2 font-semibold text-base">
          
        </div> */}
      </div>
    </div>
  );
};

export default ProfileInfoLine;
